<template>
  <div>
    <div v-if="type == 'text'">
      <lu-input
        type="text"
        clearable
        :placeholder="placeholder"
        v-model="innerValue"
      >
      </lu-input>
    </div>
    <div v-if="type == 'textarea'">
      <lu-input
        type="textarea"
        :rows="rows"
        :placeholder="placeholder"
        v-model="innerValue"
      >
      </lu-input>
      <div style="margin-top:10px">
        <lu-button type="primary" v-if="confirmBtn" @click="confirm"
          >确定</lu-button
        >
        <lu-button @click="reset">清空</lu-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "luBatchInput",
  data() {
    return {
      innerValue: "", //传入数据
      outputValue: [], //input 处理过的ids（数字数组），用以输出
      errorIds: [] //配置全部的时候，可以输出错误的ids
    };
  },
  async created() {
    this.innerValue = this.value;
  },
  props: {
    value: [String, Number],
    allList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    rows: {
      type: Number,
      default: function() {
        return 3;
      }
    },
    type: {
      type: String,
      default: function() {
        return "text";
      }
    },
    placeholder: {
      type: String,
      default: function() {
        return "";
      }
    },
    update: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    clearable: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    confirmBtn: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    resetBtn: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  watch: {
    value: function(val) {
      this.innerValue = val;
    },
    update: function(val) {
      if (val) {
        this.confirm();
      }
    }
  },
  methods: {
    confirm() {
      let splitIds = [];
      splitIds = this.innerValue.match(/\d+/g) || [];
      if (this.allList.length) {
        splitIds.forEach(id => {
          id = Number(id);
          //如果在all中而且没被添加过
          if (
            this.allList.indexOf(id) != -1 &&
            this.outputValue.indexOf(id) == -1
          ) {
            this.outputValue.push(id);
          } else {
            this.errorIds.push(id);
          }
        });
      } else {
        //如果没有配置all
        splitIds.forEach(id => {
          id = Number(id);
          if (this.outputValue.indexOf(id) == -1) {
            this.outputValue.push(id);
          }
        });
      }
      this.$emit("updated", this.outputValue, this.errorIds);
      this.outputValue = [];
      this.errorIds = [];
      this.update = false;
    },
    reset() {
      this.innerValue = "";
      this.outputValue = [];
      this.errorIds = [];
    }
  }
};
</script>
